<template>
  <el-dialog
    v-dialogDrag
    @close="closeDialog"
    class="large-dialog"
    :title="
      formProps.pageType === 'create' ? '新增' : formProps.pageType === 'update' ? '编辑' : '查看'
    "
    :visible.sync="visible"
    :close-on-click-modal="false"
  >
    <div>
      <el-form ref="form" label-width="180px" :rules="rules" :model="formData">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="作业活动名称" prop="jobName">
              <el-input
                v-model="formData.jobName"
                placeholder="请输入作业活动名称"
                maxlength="100"
                show-word-limit
                clearable
                :disabled="formProps.pageType === 'read'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="作业活动类型" prop="jobActivityType">
              <el-select
                v-model="formData.jobActivityType"
                class="w-full"
                placeholder="请选择作业活动类型"
                clearable
                filterable
                :disabled="formProps.pageType === 'read'"
              >
                <el-option
                  v-for="item in jobActivityTypeList"
                  :key="item.code"
                  :label="item.displayName"
                  :value="Number(item.code)"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="作业活动内容" prop="jobContent">
              <el-input
                v-model="formData.jobContent"
                placeholder="请输入作业活动内容"
                maxlength="100"
                show-word-limit
                clearable
                :disabled="formProps.pageType === 'read'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="作业活动编号" prop="jobNo">
              <el-input
                v-model="formData.jobNo"
                placeholder="请输入作业活动编号"
                maxlength="100"
                show-word-limit
                clearable
                :disabled="formProps.pageType === 'read'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="作业实施单位" prop="jobImplementationUnitId">
              <department-select
                v-model="formData.jobImplementationUnitId"
                placeholder="请选择作业实施单位"
                :disabled="formProps.pageType === 'read'"
              ></department-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="作业活动区域" prop="jobActivityAreaId">
              <el-select
                v-model="formData.jobActivityAreaId"
                class="w-full"
                placeholder="请选择作业活动区域"
                clearable
                filterable
                :disabled="formProps.pageType === 'read'"
              >
                <el-option
                  v-for="item in areaList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="涉及设备设施" prop="equipmentId">
              <el-select
                v-model="formData.equipmentId"
                class="w-full"
                placeholder="请选择涉及设备设施"
                filterable
                clearable
                :disabled="formProps.pageType === 'read'"
              >
                <el-option
                  v-for="item in deviceList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="作业活动频率" prop="jobActivityFrequency">
              <el-select
                v-model="formData.jobActivityFrequency"
                class="w-full"
                placeholder="请选择作业活动频率"
                clearable
                filterable
                :disabled="formProps.pageType === 'read'"
              >
                <el-option
                  v-for="item in jobActivityFrequencyList"
                  :key="item.code"
                  :label="item.displayName"
                  :value="Number(item.code)"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属风险分析单元" prop="riskAnalysisUnitId">
              <el-select
                v-model="formData.riskAnalysisUnitId"
                class="w-full"
                placeholder="请选择所属风险分析单元"
                clearable
                filterable
                :disabled="formProps.pageType === 'read'"
              >
                <el-option
                  v-for="item in unitList"
                  :key="item.id"
                  :label="item.unitName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input
                type="textarea"
                :rows="4"
                v-model="formData.remark"
                placeholder="请输入备注"
                maxlength="100"
                show-word-limit
                clearable
                :disabled="formProps.pageType === 'read'"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer" v-if="formProps.pageType !== 'read'">
      <div class="flex justify-center">
        <el-button type="primary" size="small" @click="submitForm" :loading="loading"
          >保存</el-button
        >
        <el-button @click="closeDialog" size="small">取消</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { AreaApi } from '@wiz-api/area-management'
import {
  JobActivityListApi,
  RiskAnalysisUnitApi,
  EquipmentFacilityListApi,
} from '@wiz-api/double-prevention-management'

import utils from '@/components/safety/enumField/utils'
import DepartmentSelect from '@/components/safety/DepartmentSelect/DepartmentSelect'

const areaApi = new AreaApi()
const jobActivityListApi = new JobActivityListApi()
const riskAnalysisUnitApi = new RiskAnalysisUnitApi()
const equipmentFacilityListApi = new EquipmentFacilityListApi()
export default {
  name: 'job-form',
  components: {
    DepartmentSelect,
  },
  props: {
    FormData: {
      type: Object,
      default: () => {},
    },
    /**
     * @description: 上传传递的参数
     * @param {控制弹窗显示隐藏} visible
     * @return {*}
     */
    formProps: {
      type: Object,
      default: () => {
        return {
          // create 新增 update 编辑 read 详情
          pageType: 'create',
        }
      },
    },
  },
  data() {
    return {
      visible: true,
      loading: false,
      formData: null,
      rules: {
        jobName: [{ required: true, message: '请输入活动作业名称', trigger: ['blur'] }],
        jobImplementationUnitId: [
          { required: true, message: '请选择作业实施单位', trigger: ['blur'] },
        ],
        jobActivityAreaId: [{ required: true, message: '请选择作业活动区域', trigger: ['blur'] }],
      },
      areaList: [],
      jobActivityFrequencyList: [],
      jobActivityTypeList: [],
      unitList: [],
      deviceList: [],
    }
  },
  watch: {
    FormData: {
      handler(newVal, oldVal) {
        this.formData = newVal
        this.$nextTick(() => {
          this.$refs.form.clearValidate()
        })
      },
      immediate: true,
    },
  },
  created() {
    utils.getDataCategory(
      [
        'DoublePreventionManagement.DataCategory.JobActivityType',
        'DoublePreventionManagement.DataCategory.JobActivityFrequency',
      ],
      ['jobActivityTypeList', 'jobActivityFrequencyList'],
      this
    )
    this.getAreaList()
    this.getUnitList()
    // 获取设备列表
    this.getDeviceList()
  },
  methods: {
    // 获取分析单元数据
    async getUnitList() {
      const [err, res] = await riskAnalysisUnitApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.unitList = res.items
      }
    },
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
    async getDeviceList() {
      const [err, res] = await equipmentFacilityListApi.getList()
      if (!err) {
        this.deviceList = res.items || []
      }
    },
    // 表单提交
    async submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.loading = false
          this.formData = utils.deleteFormField(this.formData)
          if (this.formProps.pageType === 'create') {
            const [err, res] = await jobActivityListApi.create({ body: this.formData })
            if (!err) {
              this.$emit('refreshList')
              this.$message({
                showClose: true,
                message: '新增成功',
                type: 'success',
              })
            }
          } else {
            const [err, res] = await jobActivityListApi.update(this.formData.id, {
              body: this.formData,
            })
            if (!err) {
              this.$emit('refreshList')
              this.$message({
                showClose: true,
                message: '编辑成功',
                type: 'success',
              })
            }
          }
          this.loading = false
        }
      })
    },
    // 关闭弹窗
    closeDialog() {
      this.$emit('cancel')
    },
  },
}
</script>

<style scoped lang="scss"></style>
